
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 307.93 307.93"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h307.93v307.93H0z"}})])]),_c('g',{attrs:{"data-name":"Calque 2"}},[_c('g',{attrs:{"data-name":"Calque 3"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M154 307.93A154 154 0 100 154a154 154 0 00154 154","fill":"#00577b"}})]),_c('g',{attrs:{"data-name":"homme touret","stroke":"#fff","stroke-width":"10"}},[_c('path',{attrs:{"d":"M151.8 147l25.31-8 11.74-37.05s12.1-15 30.07 5.5C223.33 121.72 257.8 234 257.8 234l-17.24 5.14-21.27-72.26-11.74 19.02 14.68 49.89-17.43 5.81-16.32-58.26 10.27-27.51-5.13-20.91","stroke-linecap":"round","stroke-linejoin":"round","fill":"none"}}),_c('circle',{attrs:{"cx":"176.93","cy":"66.13","r":"18.07","stroke-miterlimit":"10","fill":"none"}}),_c('circle',{attrs:{"cx":"94.32","cy":"192.57","r":"49.49","stroke-miterlimit":"10","fill":"none"}}),_c('circle',{attrs:{"cx":"94.16","cy":"192.57","r":"29.64","stroke-miterlimit":"10","fill":"none"}}),_c('circle',{attrs:{"cx":"94.24","cy":"192.63","r":"8.56","fill":"#fff","stroke-miterlimit":"10"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","fill":"none","d":"M94.32 242.06h77.48"}})])])])])
          )
        }
      }
    